import { downloadName } from './safeFilename'
import type { OutputFormat } from '../types'
import { extensionFor } from './fileValidation'

export interface DownloadOptions {
  blob: Blob
  fileName: string
  outputFormat: OutputFormat
}

export function downloadBlob(options: DownloadOptions): void {
  const { blob, fileName, outputFormat } = options
  downloadBlobAs(blob, fileName, extensionFor(outputFormat))
}

export function downloadBlobAs(blob: Blob, fileName: string, extension: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = downloadName(fileName, extension)
  a.style.display = 'none'
  document.body.appendChild(a)
  try {
    a.click()
  } finally {
    document.body.removeChild(a)
    // Give the browser a moment to start the download before revoking.
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}

export function downloadNameForBatch(outputFormat: OutputFormat): string {
  return outputFormat === 'pdf' ? 'heic-converted.pdf' : 'heic-converted.zip'
}
